import { BusinessObjectPart, BusinessObjectPartContext, ModelBase, QueryBus, Weaver } from '@skylab-shared/core';
import { Constructor } from '@skylab-shared/types';
import { not } from '@skylab-shared/utils';
import { NumberingQuery } from '../../numbering/queries/numbering.query-base';
import { ExistingDocumentsWithNumberQuery } from '../queries/existing-documents-with-number.query-base';
import { DocumentNumberCannotBeEmptyError } from '../violations/document-number-cannot-be-empty-error';
import { DocumentNumberInUseWarning } from '../violations/document-number-in-use-warning';

interface DocumentModelPart extends ModelBase {
    documentNumber: string;
    numberingId: number;
}

export class DocumentNumberBoPart extends BusinessObjectPart<DocumentModelPart> {

    public constructor(
        weaver: Weaver,
        protected readonly queryBus: QueryBus) {
        super(weaver);
    }

    public override async initializeAsync(context: BusinessObjectPartContext<DocumentModelPart>): Promise<void> {
        await super.initializeAsync(context);

        await Promise.all([
            this.bo.localContext.preload(NumberingQuery)
        ]);

        const baseDocumentNumber = this.bo.model.documentNumber;

        const modelType = <Constructor<DocumentModelPart>> this.bo.model.constructor;

        this.engine.validation.addRule(
            [[modelType, 'documentNumber'], [modelType, 'numberingId']],
            [[modelType, 'documentNumber']],
            async ctx => {
                if (!ctx.bo.model.documentNumber)
                    return true;
                const numbering = this.bo.localContext.firstPreloaded(NumberingQuery, { id: ctx.bo.model.numberingId });
                if (numbering?.manual) {
                    const documentsInUseLength = await this.queryBus.queryAsync(new ExistingDocumentsWithNumberQuery(ctx.bo.model.documentNumber));
                    if (!documentsInUseLength) return true;

                    const inUseLimit = this.bo.model.isPersistent && (baseDocumentNumber === ctx.bo.model.documentNumber) ? 1 : 0;

                    return not(documentsInUseLength > inUseLimit);
                }
                return true;
            },
            DocumentNumberInUseWarning
        );

        this.engine.validation.addRule(
            [[modelType, 'numberingId'], [modelType, 'documentNumber']],
            [[modelType, 'documentNumber']],
            ctx => not(this.bo.localContext.firstPreloaded(NumberingQuery, { id: ctx.source.numberingId })?.manual && !ctx.source.documentNumber),
            DocumentNumberCannotBeEmptyError
        );
    }
}
